import React, { useState, useEffect } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { MdArrowBackIos } from 'react-icons/md'
import { getEmployee } from '../../../API/Employee/Employee'
import { getEmployers } from '../../../API/Analytics/employers'
import ModalViewProfileInfo from '../../Service/Views/PeopleAnalytics/Components/ModalProfileInfo/ModalViewProfileInfo'
import ModalEditProfileInfo from '../../Service/Views/PeopleAnalytics/Components/ModalProfileInfo/ModalEditProfileInfo'
import { getCountry } from '../../../API/Lists/country'
import { civilStatesList, contractTypesList, genderList } from '../../../API/Employee/Profile'
import { futureCVTranslate } from '../../../i18n/translatedMessages'

import './Header.sass'
import Loading from '../../../Components/Loading/Loading'

const REGEX_ID = /(([\s\S])+[^\d+$])/g

const HeaderLayout = ({ children }) => {
	const [showProfileView, setShowProfileView] = useState(false)
	const [showProfileEdit, setShowProfileEdit] = useState(false)
	const [loading, setLoading] = useState(false)
	const [noPermission, setNoPermission] = useState(false)

	const [employee, setEmployee] = useState({
		name: '',
		email: '',
		profile: '',
	})

	const [lists, setLists] = useState({
		gender: [],
		maritalStatus: [],
		contract: [],
		country: [],
	})

	const history = useHistory()
	const pathName = history.location.pathname
	const EmployeeID = pathName.replace(REGEX_ID, '')

	useEffect(() => {
		const checkPermissionAndFetch = async () => {
			setLoading(true)
			setNoPermission(false)
			const user = JSON.parse(localStorage.getItem('user'))
			const employers = await getEmployers(user.id)
			const ids = employers.map(emp => emp.id)
			if (!ids.includes(Number(EmployeeID))) {
				setNoPermission(true)
				setLoading(false)
				return
			}
			const data = await getEmployee(EmployeeID)
			setEmployee({
				name: data?.name,
				profile: data?.employerSubAreas?.name,
				email: data?.employerUser?.email,
			})
			const [country, gender, maritalStatus, contract] = await Promise.all([getCountry(), genderList(), civilStatesList(), contractTypesList()])
			setLists({
				country,
				gender,
				maritalStatus,
				contract,
			})
			setLoading(false)
		}
		checkPermissionAndFetch()
	}, [EmployeeID])

	const handleClose = () => {
		setShowProfileEdit(false)

		if (!noPermission) {
			setLoading(true)
			getEmployee(EmployeeID).then(data => {
				setEmployee({
					name: data?.name,
					profile: data?.employerSubAreas?.name,
					email: data?.employerUser?.email,
				})
				setLoading(false)
			})
		}
	}

	return (
		<>
			{loading ? (
				<Loading />
			) : (
				<>
					<ModalViewProfileInfo
						employeeId={EmployeeID}
						show={showProfileView}
						onEditClick={() => {
							setShowProfileView(false)
							setShowProfileEdit(true)
						}}
						lists={lists}
						onCloseClick={() => setShowProfileView(false)}
						disabled={noPermission}
					/>
					<ModalEditProfileInfo
						show={showProfileEdit}
						lists={lists}
						employeeId={EmployeeID}
						onCloseClick={() => handleClose()}
						disabled={noPermission}
					/>
					<div className='row m-0 p-0'>
						<div className='col'>
							<ul className='colaborador-infos'>
								<li>
									<button className='item-circle' onClick={history.goBack}>
										<MdArrowBackIos size={30} />
									</button>
									<div>
										<span className='item-menu'>{noPermission ? '' : employee?.name}</span>
										<span className='item-menu'>{noPermission ? '' : employee?.email}</span>
										<span className='item-menu'>{noPermission ? '' : employee?.profile}</span>
									</div>
								</li>
								<li className='more-info'>
									{!noPermission && !pathName.indexOf('futurecv') !== -1 ? (
										<Link to={`/app/analytic/futurecv/${EmployeeID}`} className='btn rounded-pill btnObtenerPDF fw-bold fs-6'>
											{futureCVTranslate.showReview}
										</Link>
									) : (
										<button className='btn rounded-pill btnObtenerPDF fw-bold fs-6' disabled style={{ opacity: 0.5, pointerEvents: 'none' }}>
											{futureCVTranslate.showReview}
										</button>
									)}

									<button
										size={30}
										onClick={() => setShowProfileView(true)}
										className='link-info cursor-pointer btn p-0'
										disabled={noPermission}
										style={noPermission ? { opacity: 0.5, pointerEvents: 'none' } : {}}
									>
										{futureCVTranslate.showMore}
										<span className='item-circle-down'>
											<MdArrowBackIos size={30} />
										</span>
									</button>
								</li>
							</ul>
						</div>
					</div>
					{children}
				</>
			)}
		</>
	)
}

export default HeaderLayout
